"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Colors_1 = require("../../../Colors");
const common_1 = require("../../../common");
const actionTypes_1 = require("./actionTypes");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const DEFAULT_POPUP = {
    className: undefined,
    component: undefined,
    componentProps: undefined,
    title: undefined,
    width: 0,
    height: 0,
    isFit: false,
    isClose: true,
    noPadding: false,
};
const PopupContainer = react_1.default.memo(() => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const popupRef = react_1.default.useRef(null);
    const [popup, setPopup] = (0, react_1.useState)(DEFAULT_POPUP);
    // const outsideClick = (event: MouseEvent) => {
    // 	if (!popup) return;
    // 	if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
    // 		hidePopup();
    // 	}
    // };
    const handlerTogglePopup = (data) => {
        if (!data)
            hidePopup();
        else
            setPopup(data);
    };
    const hidePopup = () => {
        popup?.componentProps?.handlerClose && popup?.componentProps?.handlerClose();
        setPopup(DEFAULT_POPUP);
    };
    const component = (0, react_1.useMemo)(() => {
        return popup.component
            ? react_1.default.createElement(popup.component, popup.componentProps)
            : undefined;
    }, [popup]);
    const title = (0, react_1.useMemo)(() => popup.title, [popup.title]);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe(actionTypes_1.TOGGLE_POPUP, handlerTogglePopup);
    }, []);
    (0, react_1.useEffect)(() => {
        if (!component)
            return;
        const preventScroll = (e) => {
            if (popupRef.current && popupRef.current.contains(e.target))
                return;
            e.preventDefault();
        };
        document.addEventListener('wheel', preventScroll, { passive: false });
        document.addEventListener('touchmove', preventScroll, { passive: false });
        return () => {
            document.removeEventListener('wheel', preventScroll);
            document.removeEventListener('touchmove', preventScroll);
        };
    }, [component]);
    (0, react_1.useEffect)(() => {
        if (!component)
            return;
        const handleEscape = (e) => {
            if (e.key !== 'Escape')
                return;
            if (popup?.isClose === false)
                return;
            hidePopup();
        };
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [component]);
    // useEffect(() => {
    // 	window.addEventListener('click', outsideClick);
    // 	return () => {
    // 		window.removeEventListener('click', outsideClick);
    // 	};
    // }, []);
    if (!component)
        return null;
    return (react_1.default.createElement("div", { className: `popup ${popup.className} ${isDesktop ? 'desktop' : isTablet ? 'tablet' : 'mobile'}` },
        react_1.default.createElement("div", { className: "popup-wrapper", ref: popupRef, style: {
                width: `${popup?.width}px`,
                height: `${popup?.height ? `${popup?.height}px` : popup?.isFit ? 'auto' : '90%'}`,
                // minHeight: `${popup?.isFit ? 'auto' : '80%'}`,
                maxHeight: `${popup?.isFit ? 'auto' : '90%'}`,
            } },
            react_1.default.createElement("div", { className: "popup-header" },
                react_1.default.createElement("p", { className: "headline5" }, title),
                popup?.isClose !== false && (react_1.default.createElement("div", { onClick: hidePopup, style: { cursor: 'pointer' } },
                    react_1.default.createElement(common_1.Icon, { icon: "close", size: 24, fill: Colors_1.Colors.white })))),
            react_1.default.createElement("div", { className: "popup-body", style: (popup.noPadding && isMobile) ? { padding: 0 } : undefined }, component))));
});
exports.default = PopupContainer;
